import React from "react";
import { Link, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";

import Layout from "../components/Layout";
// import NewsRoll from "../components/NewsRoll";
import EventsRoll from "../components/EventsRoll";
import FullWidthImage from "../components/FullWidthImage";
import Fund150PromoEnglishImage from "../img/150-years/jvc-150-fund-ca-promo-final-english.png";
import Fund150PromoTamilImage from "../img/150-years/jvc-150-fund-ca-promo-final-tamil.png";

// eslint-disable-next-line
export const IndexPageTemplate = ({
  image,
  title,
  heading,
  subheading,
  mainpitch,
  description,
}) => {
  const heroImage = getImage(image) || image;

  return (
    <div>
      <FullWidthImage img={heroImage} title={title} subheading={subheading} />
      <section className="section section--gradient">
        <div className="container">
          <div className="section">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="content">

                  <div className="content">
                    <div className="tile">
                      <h1 className="title">{mainpitch.title}</h1>
                    </div>
                    <div className="tile">
                      <h3 className="subtitle">{mainpitch.description}</h3>
                    </div>
                  </div>

                  <div className="columns">
                    <div className="column is-12">
                      <h3 className="has-text-weight-semibold is-size-2">
                        {heading}
                      </h3>
                      <p>{description}</p>
                    </div>
                  </div>

                  <div className="column is-12">
                    <h3 className="has-text-weight-semibold is-size-2">
                      J/Victoria college's 150th Anniversary Fund 2026
                    </h3>
                    <div className="columns is-multiline">
                      <div className="is-parent column is-6">
                        <a
                          href="/150-years-college-fund/"
                        >
                          <img style={{ borderRadius: "16px" }} src={Fund150PromoTamilImage} alt="150th Anniversary Fund 2026" />
                        </a>
                      </div>
                      <div className="is-parent column is-6">   
                        <a
                          href="/150-years-college-fund/"
                        >
                          <img style={{ borderRadius: "16px" }} src={Fund150PromoEnglishImage} alt="150th Anniversary Fund 2026" />
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="column is-12">
                    <h3 className="has-text-weight-semibold is-size-2">
                      Latest Events
                    </h3>
                    <EventsRoll limit={2} />
                    <div className="column is-12 has-text-centered">
                      <Link className="btn" to="/events">
                        Read more
                      </Link>
                    </div>
                  </div>

                  <div className="columns">
                    <div className="column is-12">
                      <iframe 
                        title="Facebook Page Timeline"
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FJVC.OSA.Canada&tabs=timeline&width=340&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=674594303902967" 
                        width="340" 
                        height="500" 
                        style={{border:"none", overflow:"hidden"}} 
                        scrolling="no" 
                        frameborder="0" 
                        allowfullscreen="true" 
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
                      </iframe>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        description={frontmatter.description}
      />
    </Layout>
  );
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH)
          }
        }
        subheading
        mainpitch {
          title
          description
        }
        heading
        description
      }
    }
  }
`;
